// material-ui
import { PaletteColorOptions } from '@mui/material/styles';

//project-import
import { ThemeMode } from 'config';

//assets
import { PalettesProps } from '@ant-design/colors';

// types
import { PaletteThemeProps } from 'types/theme';

// ==============================|| PRESET THEME - DEFAULT ||============================== //

export default function Theme2(colors: PalettesProps, mode: ThemeMode): PaletteThemeProps {
  const { grey } = colors;
  const greyColors: PaletteColorOptions = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = '#fff';

  // CityOptima-inspired palette (green, warm yellows, deep blues)
  let primaryColors = ['#e8f1ff', '#c5d8f7', '#9fbdf1', '#7aa3eb', '#4f7fdc', '#0c4ca8', '#083b85', '#062e6a', '#042151', '#021536'];
  let errorColors = ['#FDE8E7', '#F25E52', '#F04134', '#EE3B2F', '#E92A21'];
  let warningColors = ['#FFF6DA', '#FFE7A3', '#F8C94A', '#F2B61C', '#D89C0F'];
  let infoColors = ['#E3F5FE', '#9BD4F7', '#4DA7E2', '#1F7AC1', '#0F4773'];
  let successColors = ['#E6F4E9', '#BEE6C5', '#6BBF72', '#3E9244', '#2C6E33'];

  if (mode === ThemeMode.DARK) {
    primaryColors = ['#0b1021', '#101a36', '#14244a', '#1b2e5b', '#25457d', '#2f5c9d', '#3d73c0', '#4a86d8', '#7aa8e6', '#b7d0f5'];
    errorColors = ['#311a1b', '#6a2624', '#b1322e', '#d14641', '#ec8b87'];
    warningColors = ['#2d250f', '#5d450f', '#a87612', '#c7901c', '#e7c86a'];
    infoColors = ['#101b27', '#153253', '#1a4b7b', '#1f639b', '#5f98d1'];
    successColors = ['#0f1d17', '#1c3d2a', '#275739', '#337049', '#5da77a'];
  }

  return {
    primary: {
      lighter: primaryColors[0],
      100: primaryColors[1],
      200: primaryColors[2],
      light: primaryColors[3],
      400: primaryColors[4],
      main: primaryColors[5],
      dark: primaryColors[6],
      700: primaryColors[7],
      darker: primaryColors[8],
      900: primaryColors[9],
      contrastText
    },
    secondary: {
      lighter: greyColors[100],
      100: greyColors[100],
      200: greyColors[200],
      light: greyColors[300],
      400: greyColors[400],
      main: greyColors[500]!,
      600: greyColors[600],
      dark: greyColors[700],
      800: greyColors[800],
      darker: greyColors[900],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: greyColors[0]
    },
    error: {
      lighter: errorColors[0],
      light: errorColors[1],
      main: errorColors[2],
      dark: errorColors[3],
      darker: errorColors[4],
      contrastText
    },
    warning: {
      lighter: warningColors[0],
      light: warningColors[1],
      main: warningColors[2],
      dark: warningColors[3],
      darker: warningColors[4],
      contrastText: greyColors[100]
    },
    info: {
      lighter: infoColors[0],
      light: infoColors[1],
      main: infoColors[2],
      dark: infoColors[3],
      darker: infoColors[4],
      contrastText
    },
    success: {
      lighter: successColors[0],
      light: successColors[1],
      main: successColors[2],
      dark: successColors[3],
      darker: successColors[4],
      contrastText
    },
    grey: greyColors
  };
}
